// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Bend} from './bend.js'
import {Color} from './color.js'
import {ConnectorCap} from './connector-cap.js'
import {ConnectorEndpoint, unionListToConnectorEndpoint, unionToConnectorEndpoint} from './connector-endpoint.js'
import {ConnectorPathStyle} from './connector-path-style.js'
import {Id} from './id.js'
import {InkStyle} from './ink-style.js'
import {InkTool} from './ink-tool.js'
import {SetFloat} from './set-float.js'

export class ModifyConnector {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyConnector {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyConnector(bb: flatbuffers.ByteBuffer, obj?: ModifyConnector): ModifyConnector {
    return (obj || new ModifyConnector()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyConnector(bb: flatbuffers.ByteBuffer, obj?: ModifyConnector): ModifyConnector {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyConnector()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  connectors(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  connectorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  startType(): ConnectorEndpoint {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ConnectorEndpoint.NONE
  }

  start<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  endType(): ConnectorEndpoint {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ConnectorEndpoint.NONE
  }

  end<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  pathStyle(): ConnectorPathStyle | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  bends(index: number, obj?: Bend): Bend | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? (obj || new Bend()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  bendsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  startCap(): ConnectorCap | null {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  endCap(): ConnectorCap | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  tool(): InkTool | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  style(): InkStyle | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  color(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  borderWidth(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  positionLocked(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  labelPosition(obj?: SetFloat): SetFloat | null {
    const offset = this.bb!.__offset(this.bb_pos, 34)
    return offset ? (obj || new SetFloat()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  static startModifyConnector(builder: flatbuffers.Builder) {
    builder.startObject(16)
  }

  static addConnectors(builder: flatbuffers.Builder, connectorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, connectorsOffset, 0)
  }

  static startConnectorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addStartType(builder: flatbuffers.Builder, startType: ConnectorEndpoint) {
    builder.addFieldInt8(1, startType, ConnectorEndpoint.NONE)
  }

  static addStart(builder: flatbuffers.Builder, startOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, startOffset, 0)
  }

  static addEndType(builder: flatbuffers.Builder, endType: ConnectorEndpoint) {
    builder.addFieldInt8(3, endType, ConnectorEndpoint.NONE)
  }

  static addEnd(builder: flatbuffers.Builder, endOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, endOffset, 0)
  }

  static addPathStyle(builder: flatbuffers.Builder, pathStyle: ConnectorPathStyle) {
    builder.addFieldInt8(5, pathStyle, null)
  }

  static addBends(builder: flatbuffers.Builder, bendsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, bendsOffset, 0)
  }

  static startBendsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addStartCap(builder: flatbuffers.Builder, startCap: ConnectorCap) {
    builder.addFieldInt8(7, startCap, null)
  }

  static addEndCap(builder: flatbuffers.Builder, endCap: ConnectorCap) {
    builder.addFieldInt8(8, endCap, null)
  }

  static addTool(builder: flatbuffers.Builder, tool: InkTool) {
    builder.addFieldInt8(9, tool, null)
  }

  static addStyle(builder: flatbuffers.Builder, style: InkStyle) {
    builder.addFieldInt8(10, style, null)
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(11, colorOffset, 0)
  }

  static addBorderWidth(builder: flatbuffers.Builder, borderWidth: number) {
    builder.addFieldFloat32(12, borderWidth, null)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(13, zIndex, null)
  }

  static addPositionLocked(builder: flatbuffers.Builder, positionLocked: boolean) {
    builder.addFieldInt8(14, +positionLocked, null)
  }

  static addLabelPosition(builder: flatbuffers.Builder, labelPositionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, labelPositionOffset, 0)
  }

  static endModifyConnector(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // connectors
    return offset
  }
}
